import React, { useEffect, Fragment, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { fetchSingleProduct } from "../redux";
import Spinner from "../components/Spinner";
import Alert from "../components/Alert";
import { Tab } from '@headlessui/react'
import GeenWinesOffer1 from "../assets/images/geen-wines-offer1.jpg";
import GeenWinesOffer2 from "../assets/images/geen-wines-offer2.jpg";
import GeenWinesOffer3 from "../assets/images/geen-wines-offer3.jpg";
import GeenWinesOffer4 from "../assets/images/geen-wines-offer4.jpg";

const Product = (props: any) => {
  const { fetchSingleProduct } = props;

  const navigation = {
    categories: [
      {
        id: 'others',
        name: 'Others',
        featured: [
          {
            name: 'Tequila',
            href: '#',
            imageSrc: GeenWinesOffer1,
            imageAlt: 'Models sitting back to back, wearing Basic Tee in black and bone.',
          },
          {
            name: 'Brandy',
            href: '#',
            imageSrc: GeenWinesOffer3,
            imageAlt: 'Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.',
          },
        ],
        sections: [
          {
            id: 'wine',
            name: 'Wine',
            items: [
              { name: 'Four Cousins', href: '#' },
            ],
          },
          {
            id: 'rum',
            name: 'Rum',
            items: [
              { name: 'Captain Morgan', href: '#' }
            ],
          },
          {
            id: 'liqueurs',
            name: 'Liqueurs',
            items: [
              { name: 'Hennessey', href: '#' }
            ],
          },
        ],
      },
      {
        id: 'offers',
        name: 'Offers',
        featured: [
          {
            name: 'New Arrivals',
            href: '#',
            imageSrc: GeenWinesOffer2,
            imageAlt: 'Geen Wines',
          },
          {
            name: 'Fine Stuff',
            href: '#',
            imageSrc: GeenWinesOffer4,
            imageAlt:
              'Geen Wines',
          },
        ],
        sections: [
          {
            id: 'wine',
            name: 'Wine',
            items: [
              { name: 'Four Cousins', href: '#' },
            ],
          },
          {
            id: 'rum',
            name: 'Rum',
            items: [
              { name: 'Captain Morgan', href: '#' }
            ],
          },
          {
            id: 'liqueurs',
            name: 'Liqueurs',
            items: [
              { name: 'Hennessey', href: '#' }
            ],
          },
        ],
      },
    ]
  }

  const classNames = (...classes:any)  => {
    return classes.filter(Boolean).join(' ')
  }
  let params = useParams();
  const productId = params.product_id;

  const [product, setProduct] = useState(Object);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  console.log(productId);

  useEffect(() => {
    const handleAsync = async () => {
      fetchSingleProduct(productId, (res: any) => {
        const { data, status } = res;

        if (status === "info") {
          setProduct(data[0]);
        }
        setIsLoading(false);
      });
    };
    handleAsync();
    // eslint-disable-next-line
  }, [productId]);

  setTimeout(() => {
    setStatus("");
    setMessage("");
  }, 2000);

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <main className="py-6 px-4 sm:p-6 md:py-10 md:px-8">
          <div className="max-w-4xl mx-auto grid grid-cols-1 lg:max-w-5xl lg:gap-x-20 lg:grid-cols-2">
            {status !== "" && <Alert status={status} message={message} />}

            <div className="grid gap-4 col-start-1 col-end-3 row-start-1 sm:mb-6 sm:grid-cols-4 lg:gap-6 lg:col-start-2 lg:row-end-6 lg:row-span-6 lg:mb-0 border-2 border-black rounded-3xl overflow-hidden">
              {product?.image_url !== "" ? (
                <img
                  src={product.image_url}
                  alt={product.name}
                  className="w-full rounded-lg sm:col-span-2 lg:col-span-full"
                  loading="lazy"
                />
              ) : (
                <div className="border border-red-300 p-2">
                  Product has no image.
                </div>
              )}
            </div>

            <div className="flex justify-between mt-8">
              <div className="max-w-[35ch]">
                <h1 className="text-2xl mb-4 font-bold">{product?.name}</h1>
                <dl className="my-4 text-xs font-medium flex items-center row-start-2 sm:mt-1 sm:row-start-3 md:mt-2.5 lg:row-start-2">
                  <dt className="sr-only">Reviews</dt>
                  <dd className="text-indigo-600 flex items-center dark:text-indigo-400">
                    <svg
                      width={24}
                      height={24}
                      fill="none"
                      aria-hidden="true"
                      className="mr-1 stroke-current dark:stroke-indigo-500"
                    >
                      <path
                        d="m12 5 2 5h5l-4 4 2.103 5L12 16l-5.103 3L9 14l-4-4h5l2-5Z"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>
                      4.89{" "}
                      <span className="text-slate-400 font-normal">(128)</span>
                    </span>
                  </dd>
                  <dt className="sr-only">Category</dt>
                  <dd className="flex items-center">
                    <svg
                      width={2}
                      height={2}
                      aria-hidden="true"
                      fill="currentColor"
                      className="mx-3 text-slate-300"
                    >
                      <circle cx={1} cy={1} r={1} />
                    </svg>
                    <svg
                      width={24}
                      height={24}
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="mr-1 text-slate-400 dark:text-slate-500"
                      aria-hidden="true"
                    >
                      <path d="M18 11.034C18 14.897 12 19 12 19s-6-4.103-6-7.966C6 7.655 8.819 5 12 5s6 2.655 6 6.034Z" />
                      <path d="M14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
                    </svg>
                    {/* { product.category && product?.category} */}
                  </dd>
                </dl>
              </div>
              <p className="text-lg font-bold">$119.99</p>
            </div>

            <div>
              <p className="my-8 text-sm leading-6 col-start-1 sm:col-span-2 lg:mt-4 lg:row-start-4 lg:col-span-1 dark:text-slate-400">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa
                veniam dicta beatae eos ex error culpa delectus rem tenetur,
                architecto quam nesciunt, dolor veritatis nisi minus inventore,
                rerum at recusandae?
              </p>
            </div>

            <div className="flex justify-between mt-4">
              <div>
                <label htmlFor="quantity" className="sr-only">
                  Qty
                </label>
                <input
                  type="number"
                  id="quantity"
                  min={1}
                  defaultValue={1}
                  className="px-1 py-3 text-sm text-center rounded border border-gray-600"
                />
              </div>
              <button
                type="submit"
                className="px-4 bg-green-700 text-white text-sm leading-6 font-medium py-2 rounded-lg"
              >
                Add to Cart
              </button>
            </div>
          </div>
          <section>
            <div className="max-w-screen-xl px-4 py-8 mx-auto">
              <div className="relative max-w-3xl mx-auto text-center">
                <span className="absolute inset-x-0 h-px -translate-y-1/2 bg-black/10 top-1/2" />
                <h2 className="relative inline-block px-4 text-2xl font-bold text-center bg-white">
                  Recently Viewed
                </h2>
              </div>
            </div>
            <div className="w-full max-w-md px-2 py-16 sm:px-0 sm:mb-80">

              {/* TODO: Fix display */}
      <Tab.Group>
        <Tab.List className="flex space-x-1 rounded-xl bg-blue-900 p-1">
          {navigation.categories.map((category) => (
            <Tab
              className={({ selected }) =>
                classNames(
                  'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700',
                  'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                  selected
                    ? 'bg-white shadow'
                    : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                )
              }
            >
              {category.name}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-2">
          {navigation.categories.map((category) => (
            <Tab.Panel
              key={category.name}
              className={classNames(
                'rounded-xl bg-white p-3',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2'
              )}
            >
            <div className="absolute top-full inset-x-0 text-sm text-gray-500">
                {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
                <div className="absolute inset-0 top-1/2 bg-white shadow" aria-hidden="true" />
                <div className="relative bg-white">
                  <div className="max-w-7xl mx-auto px-8">
                    <div className="grid grid-cols-2 gap-y-10 gap-x-8 py-16">
                      <div className="col-start-2 grid grid-cols-2 gap-x-8">
                        {category.featured.map((item) => (
                          <div key={item.name} className="group relative text-base sm:text-sm">
                            <div className="aspect-w-1 aspect-h-1 rounded-lg bg-gray-100 overflow-hidden group-hover:opacity-75">
                              <img
                                src={item.imageSrc}
                                alt={item.imageAlt}
                                className="object-center object-cover"
                              />
                            </div>
                            <a href={item.href} className="mt-6 block font-medium text-gray-900">
                              <span className="absolute z-10 inset-0" aria-hidden="true" />
                              {item.name}
                            </a>
                            <p aria-hidden="true" className="mt-1">
                              Shop now
                            </p>
                          </div>
                        ))}
                      </div>
                      <div className="row-start-1 grid grid-cols-3 gap-y-10 gap-x-8 text-sm">
                        {category.sections.map((section) => (
                          <div key={section.name}>
                            <p id={`${section.name}-heading`} className="font-medium text-gray-900">
                              {section.name}
                            </p>
                            <ul
                              aria-labelledby={`${section.name}-heading`}
                              className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
                            >
                              {section.items.map((item) => (
                                <li key={item.name} className="flex">
                                  <a href={item.href} className="hover:text-gray-800">
                                    {item.name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
          </section>


        </main>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchSingleProduct: (id: any, callbackFunction: any) =>
      dispatch(fetchSingleProduct(id, callbackFunction)),
  };
};
export default connect(null, mapDispatchToProps)(Product);
